import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

import { styles } from './style';

interface PageProps {
    children: ReactNode;
}

const Page = ({ children }: PageProps) => <Box sx={styles.layout}>{children}</Box>;

export default Page;
